import { HorizontalDivider, Modal, Typography } from '@smartgift/frontend-toolkit';
import merge from 'lodash/merge';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useUpdateTagContacts } from '@hero/services/contact-service/hooks';

import { DoubleContactTable } from '../../Contacts';

const EditTagModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

function EditTagContactsModal({
  openModal,
  onRequestClose,
  selectedTags,
  updatableFields = [],
  disabledColumns = []
}) {
  const { t } = useTranslation();
  const [selectedTagContacts, setSelectedTagContacts] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const { mutateAsync: updateTagContacts } = useUpdateTagContacts();

  useEffect(() => {
    let list = [];
    selectedTags.map(item => merge(list, item.contacts));
    setSelectedTagContacts(list?.reduce((result, tag) => ({ ...result, [tag]: true }), {}));
  }, [selectedTags]);

  const updateContacts = async () => {
    try {
      setIsLoading(true);
      await updateTagContacts({
        id: selectedTags?.[0].id,
        body: {
          contactIds: Object.keys(selectedTagContacts)
        }
      });
    } finally {
      setIsLoading(true);
      onRequestClose();
    }
  };

  return (
    <Modal
      isOpen={openModal}
      onRequestClose={onRequestClose}
      title={
        updatableFields?.length > 0
          ? t('updateRequiredFields')
          : t('showEditContactsText', { name: selectedTags?.map(tag => tag.name) })
      }
      primaryButtonProps={{
        children: t('save'),
        onClick: () => {
          updateContacts();
        },
        loading: isLoading
      }}
      secondaryButtonProps={{
        children: t('cancel')
      }}
      size="xl"
    >
      <EditTagModalContentWrapper>
        <Typography variant="body1Bold">{t('addRemoveContactFromTagDesc')}</Typography>
        <HorizontalDivider />
        <DoubleContactTable
          isModal
          selectedRows={selectedTagContacts}
          onChangeSelectedRows={setSelectedTagContacts}
          featureType="tag"
          translations={{
            removeContactTitle: t('taggedContacts'),
            removeContactTotalCountText: 'totalContacts'
          }}
          disabledColumns={disabledColumns}
        />
      </EditTagModalContentWrapper>
    </Modal>
  );
}

export { EditTagContactsModal };
